export const applicationName = global.APPLICATION_NAME;